import React from "react";
import HeroBadge from "./HeroBadge";
import HeroHeadline from "./HeroHeadline";
import HeroStatBar from "./HeroStatBar";
import HeroTimeline from "./HeroTimeline";
import HeroCtaSection from "./HeroCtaSection";
import { CTA_COPY } from "./heroContent";

const HeroSection = ({ onOpenSignup }) => (
  <section
    className="relative pt-28 lg:pt-36 pb-24 lg:pb-20 px-6 radial-gradient-hero-roofing bg-graphite-gradient"
    data-testid="hero-section"
  >
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 lg:items-start">
      {/* Left: badge + headline + summary */}
      <div className="order-1 flex flex-col">
        <HeroBadge />
        <HeroHeadline />
        <HeroStatBar />
        <p className="text-gray-400 mt-6 text-sm md:text-base font-body">
          {CTA_COPY.summary}
        </p>
      </div>

      {/* Right: timeline + CTA */}
      <div className="order-2">
        <HeroTimeline />
        <HeroCtaSection onOpenSignup={onOpenSignup} />
      </div>
    </div>
  </section>
);

export default HeroSection;
